import * as dot from 'dot';
import { z } from 'zod';

import * as dataLoaders from '../@data-loaders';
import { toFeedback } from '../shared/to-feedback';

import { createFeedbackElement } from './@dom/create-feedback-element';
import { getWidgetConfig } from './shared/get-widget-config';

const configSchema = z.object({
    dataLoaders: z.array(z.string()),
    skeletonLines: z.number(),
});

class RenderWidget extends HTMLElement {
    async connectedCallback() {
        const feedback = createFeedbackElement(this);
        const widgetConfig = await getWidgetConfig(this).catch((err) => {
            toFeedback([err.message], feedback);
            throw err;
        });
        const config = configSchema.parse(widgetConfig);
        const templateHTML = this.innerHTML;
        this.innerHTML = `<span class="flex animate-pulse leading-tight rounded bg-gray-300 dark:bg-gray-600">&nbsp;</span>`.repeat(
            config.skeletonLines,
        );

        const loadingData = config.dataLoaders.map(async (dataLoaderName) => {
            if (!(dataLoaderName in dataLoaders)) {
                const errorMessage = `DataLoader "${dataLoaderName}" not found.`;
                feedback.innerHTML += errorMessage;
                throw new Error(errorMessage);
            }

            const result: any = await (dataLoaders as any)[dataLoaderName]().catch((err: unknown) => {
                console.error(err);
            });

            return result;
        });

        const dataToMerge = await Promise.all(loadingData);
        const data = dataToMerge.reduce((acc, merge) => {
            return {
                ...acc,
                ...merge,
            };
        }, {});

        const template = dot.template(templateHTML);
        this.innerHTML = template(data);
    }
}

customElements.define(`mh-render`, RenderWidget);

export default RenderWidget;
